import { isInSaaSMode } from '../utils/common';
import useEnvironment from './useEnvironment';

const useHasDbtProjects = () => {
  const environment = useEnvironment();

  if (!isInSaaSMode()) {
    return true;
  }
  return environment?.hasDbtProjects ?? true;
};

export default useHasDbtProjects;
